import { memo, useEffect, type VFC, type CSSProperties, type ReactNode } from 'react'
import { Button, Modal, ModalBody, ModalCloseButton, ModalFooter, ModalHeader, useModal } from '@panwds/react-ui'
import { _T } from '../../i18n'
import { isString } from '../../framework/utils'

import type { loggedInPrompt } from '../../framework/stateTypes'

type LoggedInPromptModalProps = loggedInPrompt & {
  closeModal: () => void
}

const renderText = (text: ReactNode) => {
  if (!isString(text)) {
    return text
  }
  return text.split('\n').map((line, index) => (
    <div key={index}>{line}</div>
  ))
}

const LoggedInPromptModal: VFC<LoggedInPromptModalProps> = ({ title, message, confirmText, closeText, onConfirm, onClose, closeModal }) => {
  return <Modal
    isOpen={true}
    onClose={() => {
      closeModal()
      if (onClose) {
        onClose()
      }
    }}
    size={'md'}
    style={{
      minHeight: 50,
      zIndex: 99999,
    } as CSSProperties}
  >
    <ModalHeader title={title} />
    <ModalBody>{renderText(message)}</ModalBody>
    <ModalFooter>
      {onConfirm && <Button appearance='primary' onClick={onConfirm}>{confirmText || _T('Confirm')}</Button>}
      <ModalCloseButton>{closeText || _T('Close')}</ModalCloseButton>
    </ModalFooter>
  </Modal>
}
const MemoModal = memo(LoggedInPromptModal)

export const useLoggedInPrompt = (prompt?: loggedInPrompt) => {
  const { openModal, closeModal } = useModal(MemoModal)
  useEffect(() => {
    if (prompt) {
      openModal({ ...prompt, closeModal })
    }
  }, [closeModal, openModal, prompt])
}
